import { M as Market, l as logger, d as getFlagValue, m as mergeVehicle } from './logger-faaf508a.js';
import { h as http, c as configService } from './quoteService-727472be.js';

var VehicleCategory;
(function (VehicleCategory) {
  VehicleCategory["PC"] = "PC";
  VehicleCategory["VAN_PRIVATE"] = "VAN_PRIVATE";
  VehicleCategory["VAN_COMMERCIAL"] = "VAN_COMMERCIAL";
})(VehicleCategory || (VehicleCategory = {}));

/*
 * Vehicle prices
 */
const mapEquipments = (options) => {
  const { equipments, currency, market, locale, fallbackLocale } = options;
  return equipments.map((item) => {
    let prices;
    if (!!item.optionPrice && market !== Market.Germany) {
      const rawValue = Number(item.optionPrice) || null;
      if (rawValue) {
        const charges = [];
        prices = [
          {
            id: 'grossPrice',
            currency,
            rawValue,
            charges,
          },
        ];
      }
    }
    return {
      code: item.code,
      codeType: item.codeType,
      name: item.name[locale] || item.name[fallbackLocale],
      prices,
    };
  });
};
function getVehiclePrices(options) {
  var _a;
  const { vehiclePrices, vehicleCampaigns, currentMarket, flags, ocapiVersion = 'v2', } = options;
  const { vatPercentage = 0, grossConfigListPrice, listRoadPriceTotal, grossBasisPrice, campaignPurchasePrice, campaignPurchasePriceExclGovtGrant, priceCurrency, transactionPrices, local, } = vehiclePrices;
  const vatAmount = Number(vatPercentage) / 100 + 1;
  logger.log('vatAmount - ', vatAmount)();
  const grossListPriceValue = currentMarket === Market.Germany
    ? grossConfigListPrice
    : listRoadPriceTotal;
  const additionalValues = [];
  const prices = [
    {
      id: 'grossListPrice',
      currency: priceCurrency,
      rawValue: Number(grossListPriceValue),
      charges: [],
    },
    {
      id: 'baseListPrice',
      currency: priceCurrency,
      rawValue: Number(grossBasisPrice),
      charges: [],
    },
  ];
  if (vehicleCampaigns && currentMarket != Market.Germany) {
    const campaign = (_a = Object.values(vehicleCampaigns).filter((item) => item.campaignSource === 'BEST_OFFER')) === null || _a === void 0 ? void 0 : _a[0];
    if (campaign) {
      additionalValues.push({
        type: 'environmentalBonusGovernment',
        rawAmount: Math.abs(Number(campaign.discountGovtAmount)),
      });
    }
  }
  const purchasePriceValue = currentMarket === Market.Italy && campaignPurchasePrice
    ? campaignPurchasePrice
    : campaignPurchasePriceExclGovtGrant;
  if (purchasePriceValue && currentMarket != Market.Germany) {
    prices.push({
      id: 'purchasePrice',
      currency: priceCurrency,
      rawValue: Number(purchasePriceValue),
      charges: [],
    });
  }
  /*
   Edge cases per market
  */
  switch (currentMarket) {
    case Market.Austria:
      const ATpricesMapped = {};
      transactionPrices.forEach((price) => {
        ATpricesMapped[price.classification] = price;
      });
      const vdsOCAPIMap = [
        {
          vdsId: 'LEASING_BUSINESS',
          ocapiId: 'transactionPriceBusinessLeasing',
        },
        {
          vdsId: 'LEASING_PRIVATE',
          ocapiId: 'transactionPricePrivateLeasing',
        },
      ];
      vdsOCAPIMap.forEach(({ ocapiId, vdsId }) => {
        var _a, _b;
        if (ATpricesMapped[vdsId] &&
          Object.keys(ATpricesMapped[vdsId]).length) {
          const charges = [
            {
              type: 'vat',
              rawAmount: ATpricesMapped[vdsId].totalCalculationVatAmount,
              rawRate: ATpricesMapped[vdsId].totalCalculationVatRate,
            },
            {
              type: 'nova',
              rawAmount: ((_a = ATpricesMapped[vdsId].localTaxCalculations) === null || _a === void 0 ? void 0 : _a.novaTotal) || 0,
              rawRate: ((_b = ATpricesMapped[vdsId].localTaxCalculations) === null || _b === void 0 ? void 0 : _b.novaRate) || 0,
            },
          ];
          prices.push({
            id: ocapiId,
            charges,
            currency: ATpricesMapped[vdsId].priceCalculationCurrency,
            rawValue: Math.abs(Number(ATpricesMapped[vdsId].totalCalculationTotalValueAfterTax)),
          });
        }
      });
      break;
    case Market.Netherlands:
      prices.forEach((price) => {
        if (price.id === 'grossListPrice') {
          price.charges.push({
            label: 'BPM',
            rawAmount: Number(local.localBpm),
            type: 'bpm',
          });
        }
      });
      break;
    case Market.Germany:
      prices.push({
        id: 'purchasePrice',
        currency: priceCurrency,
        rawValue: Number(listRoadPriceTotal),
        charges: [],
      });
      if (getFlagValue(flags, 'environment-price-mapping') && local) {
        if (ocapiVersion === 'v2') {
          prices.push({
            id: 'DE.environmentalBonusManufacturer',
            currency: priceCurrency,
            rawValue: Math.abs(Number(local.umweltbonusOem)) * vatAmount || 0,
            charges: [],
          });
          prices.push({
            id: 'DE.environmentalBonusGovernment',
            currency: priceCurrency,
            rawValue: Math.abs(Number(local.umweltbonusGovernment)) || 0,
            charges: [],
          });
        }
        else {
          additionalValues.push({
            type: 'environmentalBonusManufacturer',
            rawAmount: Math.abs(Number(local.umweltbonusOem)) * vatAmount || 0,
          });
          additionalValues.push({
            type: 'environmentalBonusGovernment',
            rawAmount: Math.abs(Number(local.umweltbonusGovernment)) || 0,
          });
        }
      }
      break;
    case Market.Sweden:
      const SEpricesMapped = {};
      transactionPrices.forEach((price) => {
        SEpricesMapped[price.classification] = price;
      });
      const prefix = ocapiVersion === 'v2' ? 'SE.' : '';
      const transactionPriceMap = [
        {
          vdsId: 'LEASING_PRIVATE',
          ocapiId: `${prefix}transactionPricePrivateLeasing`,
        },
        {
          vdsId: 'LEASING_BUSINESS',
          ocapiId: `${prefix}transactionPriceBusinessLeasing`,
        },
        {
          vdsId: 'FINANCING_PRIVATE',
          ocapiId: `${prefix}transactionPricePrivateFinancing`,
        },
        {
          vdsId: 'FINANCING_BUSINESS',
          ocapiId: `${prefix}transactionPriceBusinessFinancing`,
        },
      ];
      transactionPriceMap.forEach(({ ocapiId, vdsId }) => {
        if (SEpricesMapped[vdsId] &&
          Object.keys(SEpricesMapped[vdsId]).length) {
          prices.push({
            id: ocapiId,
            charges: [],
            currency: SEpricesMapped[vdsId].priceCalculationCurrency,
            rawValue: Math.abs(Number(SEpricesMapped[vdsId].totalCalculationTotalValueAfterTax)),
          });
        }
      });
      break;
  }
  logger.log('transformed prices', prices)();
  return {
    prices,
    additionalValues,
  };
}

const transformVehicleCategory = (category) => {
  switch (category) {
    case VehicleCategory.PC:
      return 'pc';
    case VehicleCategory.VAN_PRIVATE:
    case VehicleCategory.VAN_COMMERCIAL:
      return 'van';
    case null:
      return undefined;
    default:
      return category;
  }
};
class VDSService {
  getVehicleById(config, configService) {
    const url = configService.config.vehicleDataSource.url.replace('{vehicleId}', config.vehicleId);
    this.config = config;
    return http(url)
      .then(async (vdsResponse) => {
      const vehicle = await this.transform(vdsResponse.data, configService.config);
      logger.log('transformed vehicle', vehicle)();
      return vehicle;
    })
      .catch(async (response) => {
      // response might be error object coming from transform method
      let error = {
        message: '',
        statusCode: '',
        code: 'VDS_ERROR',
      };
      if (response instanceof Response) {
        error = Object.assign(Object.assign({}, error), { message: 'VDS: Unknown error', statusCode: response.status });
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.indexOf('application/json') !== -1) {
          const backendError = await response.json();
          error = Object.assign(Object.assign({}, error), { message: backendError.message });
        }
      }
      else if (response.message) {
        // FcisError
        error = Object.assign(Object.assign({}, error), { message: response.message });
      }
      return Promise.reject(error);
    });
  }
  async transform(data, config) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const { flags, ocapiParams } = config;
    const vdsVehicle = data.vehicleData;
    if (!vdsVehicle) {
      return Promise.reject({
        message: 'VDS vehicleData does not exist.',
      });
    }
    const { market, locale } = this.config;
    const fallbackLocale = 'en';
    const storeLocale = locale.substr(0, 2);
    const brand = vdsVehicle.brand.toLowerCase().replace('_', '-');
    const salesDescription = vdsVehicle.name[storeLocale] || vdsVehicle.name[fallbackLocale] || '';
    const { prices, additionalValues } = getVehiclePrices({
      vehiclePrices: vdsVehicle.price,
      vehicleCampaigns: vdsVehicle.campaigns,
      currentMarket: market.toUpperCase(),
      flags,
      ocapiVersion: ocapiParams.version,
    });
    const fuelType = {
      id: 'fuelType',
      value: vdsVehicle.fuelType,
    };
    const maxLoad = {
      id: 'maxLoad',
      value: (_a = vdsVehicle.maxLoad) === null || _a === void 0 ? void 0 : _a.toString(),
    };
    const maxWeight = {
      id: 'maxWeight',
      value: (_b = vdsVehicle.maxWeight) === null || _b === void 0 ? void 0 : _b.toString(),
    };
    const combustionPower = {
      id: 'combustionPowerKw',
      value: (_d = (_c = vdsVehicle.engineData) === null || _c === void 0 ? void 0 : _c.combustionPowerKw) === null || _d === void 0 ? void 0 : _d.toString(),
    };
    const electricPower = {
      id: 'electricPowerKw',
      value: (_f = (_e = vdsVehicle.engineData) === null || _e === void 0 ? void 0 : _e.electricPowerKw) === null || _f === void 0 ? void 0 : _f.toString(),
    };
    const combinedPower = {
      id: 'combinedPowerKw',
      value: (_h = (_g = vdsVehicle.engineData) === null || _g === void 0 ? void 0 : _g.combinedPowerKw) === null || _h === void 0 ? void 0 : _h.toString(),
    };
    const coEmissionObject = (_l = (_k = (_j = vdsVehicle.emission) === null || _j === void 0 ? void 0 : _j.uidata) === null || _k === void 0 ? void 0 : _k.attributes) === null || _l === void 0 ? void 0 : _l.find((item) => item.id === '85W');
    const co2EmissionWltp = {
      id: 'co2EmissionWltp',
      value: coEmissionObject === null || coEmissionObject === void 0 ? void 0 : coEmissionObject.value.toString(),
    };
    const technicalData = [
      fuelType,
      combustionPower,
      electricPower,
      combinedPower,
      co2EmissionWltp,
      maxLoad,
      maxWeight,
    ].filter((item) => !!item.value);
    const equipments = mapEquipments({
      equipments: vdsVehicle.equipments,
      currency: vdsVehicle.price.priceCurrency,
      market: this.config.market,
      locale: storeLocale,
      fallbackLocale: fallbackLocale,
    });
    const technicalIdReference = market !== Market.Germany ? data.commissionNumber : undefined;
    return {
      name: vdsVehicle.name[storeLocale] || vdsVehicle.name[fallbackLocale],
      prices,
      technicalData,
      additionalValues,
      technicalIdReference,
      vehicleConfiguration: {
        baumuster: vdsVehicle.baumuster.substring(0, 7),
        brand,
        division: transformVehicleCategory(vdsVehicle.vehicleCategory),
        equipments,
        modelYear: vdsVehicle.modelYear,
        nst: vdsVehicle.nationalType,
        retailerId: vdsVehicle.dealerId,
        salesDescription,
      },
    };
  }
}
const vdsService = new VDSService();

async function getVehicleByConfig(config, confService = configService) {
  let vehicle;
  if (!config.vehicle && !config.vehicleId) {
    throw {
      code: 'FCIS_ERROR',
      message: 'vehicle or vehicleId needs to be passed into init() method',
    };
  }
  if (config.vehicleId) {
    vehicle = await fetchVehicle(config, confService);
    if (config.vehicle) {
      vehicle = mergeVehicle(vehicle, config.vehicle);
    }
  }
  else if (config.vehicle) {
    vehicle = config.vehicle;
  }
  if (!vehicle) {
    // noinspection ExceptionCaughtLocallyJS
    throw {
      code: 'FCIS_ERROR',
      message: 'Vehicle could not be resolved from input parameters',
    };
  }
  return vehicle;
}
function fetchVehicle(config, confService) {
  const { vehicleDataSource } = confService.config;
  if (vehicleDataSource && vehicleDataSource.name === 'VDS') {
    return vdsService.getVehicleById(config, confService);
  }
  return null;
}

export { getVehicleByConfig as g };
